import { Grid, Paper, styled, Typography } from "@mui/material";
import ValidateOTP from "../../components/auth/ValidateOTP";
import { REACT_APP_WHITELABEL_LOGO_URL } from "../../utils/axios";
import { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";

const Wrapper = styled(Paper)`
    padding: ${props => props.theme.spacing(6)};

    ${props => props.theme.breakpoints.up("md")} {
        padding: ${props => props.theme.spacing(10)};
    }
`;

function ValidateOtp() {
    const [logoURL, setLogoURL] = useState(REACT_APP_WHITELABEL_LOGO_URL);
    let intervalID = null;
    useEffect(() => {
        if (logoURL) {
            intervalID = null;
        } else {
            intervalID = setInterval(() => {
                setLogoURL(REACT_APP_WHITELABEL_LOGO_URL);
            }, 500);
        }
        return () => {
            clearInterval(intervalID);
        }
    }, [REACT_APP_WHITELABEL_LOGO_URL]);

    return (
        <Grid container className='loginPage'>

            <Grid item md={2} alignContent={"flex-start"}>
                <img src={logoURL} className='login-page-logo-img' />
            </Grid>
            <Grid alignItems={"center"} md={10}>
                <Wrapper>
                    <Helmet title='Sign In' />

                    <Typography variant='h2' align='center'>
                        Validate
                    </Typography>
                    <ValidateOTP />
                </Wrapper>
            </Grid>
        </Grid>
    );

}

export default ValidateOtp;